<script>
  export default{
    name : 'NewsInfoIcon',
  }
</script>

<template>
  <g>
    <g>
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#f83600;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#fe8c00;stop-opacity:1" />
        </linearGradient>
      </defs>
    </g>
    <g transform="translate(0,-952.36218)">
      <path fill="url(#grad1)" style="enable-background:accumulate;" d="m 25,969.36217 0,59.00003 c 0,3.878 -3.122,7 -7,7 l 62,0 c 3.878,0 7,-3.122 7,-7 l 0,-59.00003 z m 10,10 20,0 0,14.00002 -20,0 z m 28,0 14,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -14,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m -50,26.00003 0,23 c 0,2.8046 2.1954,5 5,5 2.8046,0 5,-2.1954 5,-5 l 0,-23 z m 50,-16.00001 14,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -14,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m -28,12.00001 42,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -42,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 0,11 42,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -42,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 0,11 42,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -42,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z"  stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"/>
    </g>
  </g>
</template>
